import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CAMPAIGN, CampaignStateType, TaboolaCampaigns } from "./campaignTypes";
import { AppExceptionType } from "../../../types/ErrorTypes";

const initialState: CampaignStateType = {
  campaings: [],
  isLoadingFetchCampaigns: false,
  errorFetchingCampaigns: null,
};

export const campaignSlice = createSlice({
  name: CAMPAIGN,
  initialState,
  reducers: {
    resetCampaignsAll: (state: CampaignStateType) => {
      state = initialState;
      return state;
    },
    fetchCampaigns: (state: CampaignStateType) => {
      state.isLoadingFetchCampaigns = true;
    },
    fetchCampaignsSuccess: (
      state: CampaignStateType,
      action: PayloadAction<TaboolaCampaigns>
    ) => {
      state.isLoadingFetchCampaigns = false;
      state.campaings = action.payload;
    },
    fetchCampaignsError: (
      state: CampaignStateType,
      action: PayloadAction<AppExceptionType>
    ) => {
      state.isLoadingFetchCampaigns = false;
      state.errorFetchingCampaigns = action.payload;
    },
  },
});

export const {
  resetCampaignsAll,
  fetchCampaigns,
  fetchCampaignsSuccess,
  fetchCampaignsError,
} = campaignSlice.actions;

export default campaignSlice.reducer;
